import React from "react"
import PageTitle from "~/library/PageTitle"
import TasksManager from "~/views/Workspace/Tasks/TasksManager"

const TasksList: React.FC = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-12">
                            <div className="container-fluid">
                                <PageTitle title="Tasks" />
                            </div>
                        </div>
                    </div>
                    <TasksManager />
                </div>
            </div>
        </>
    )
}

export default TasksList
